import { nextModelId } from '@app/util';

export const processStrategyForChild = (parentName: string) => (value, parent) => {
  if (!value.id) {
    value.id = nextModelId();
  }
  return {...value, [`${parentName}Id`]: parent.id};
};

export const processStrategyForParent = value => {
  if (!value.id) {
    value.id = nextModelId();
  }
  return {...value};
};
